import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BookModel } from '../interfaces/book.interface';
import { AppDispatch, RootState, store } from './store';
import { editStory } from './thunks/story.thunk';

export interface IStoryData extends BookModel {}

interface StoryState {
  storyNewCharacter: boolean;
  storyData: IStoryData;
  isLoading: boolean;
}

const initialState: StoryState = {
  storyNewCharacter: true,
  isLoading: false,
  storyData: {
    gettingError: false,
    uploadedImage: null,
    characterBuilding: false,
    showLibrary: false,
    storybuildingError: false,
    isDummyPic: false,
    creditsPerBookLimit: 0,
    newRefImageUploaded: false,
  },
};

const storySlice = createSlice({
  name: 'story',
  initialState,
  reducers: {
    setStoryNewCharacter(state, action: PayloadAction<boolean>) {
      state.storyNewCharacter = action.payload;
    },
    setStoryData(state, action: PayloadAction<Partial<IStoryData>>) {
      state.storyData = { ...state.storyData, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(editStory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(editStory.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(editStory.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export const { setStoryNewCharacter, setStoryData } = storySlice.actions;

export const selectStory = (state: RootState) => state.story;

export const runEditStory =
  (params: { book: BookModel | null; navigate: (path: string) => void }) => async (dispatch: AppDispatch) => {
    try {
      const book = await dispatch(editStory({ propBook: params.book, navigate: params.navigate }));
      return book;
    } catch (error) {}
  };

export const storyStore = () => {
  const dataStore = selectStory(store.getState());

  return { ...dataStore };
};

export default storySlice.reducer;
